<script>
import baseMixin from '@mixins/baseMixin'
import TheProfileDropdown from '@/components/layout/the-profile-dropdown.vue'
import NotificationButton from '@components/message/notification-button.vue'

export default {
  name: 'TheTopBar',
  components: {
    TheProfileDropdown,
    NotificationButton,
  },
  mixins: [baseMixin],
  methods: {
    toggleDrawer() {
      this.$emit('toggleDrawer')
    },
  },
}
</script>

<template>
  <v-app-bar
    app
    clipped-left
    flat
    height="72"
    :class="['top-bar__app-bar py-0', !isDarkMode ? 'white' : '']"
  >
    <!--  -->
    <v-app-bar-nav-icon @click="toggleDrawer" />

    <v-spacer />
    <NotificationButton />
    <TheProfileDropdown class="ml-2" />
  </v-app-bar>
</template>

<style lang="scss" scoped>
.top-bar__app-bar {
  border-bottom: 1px solid rgb(0 0 0 / 12%) !important;
}
</style>
